import { SearchCriteria } from "./search-criteria";

export class SendOTPCodeToClientSearchCriteria extends SearchCriteria {
  public GiftCardCode: string;
  public GiftCardAmount: number;
}
